import React from "react";
import { Icon } from "../../UIElements/Icon";
import { useTranslation } from "react-i18next";

const OrdersError = ({ error, onRetry }) => {
  const { t } = useTranslation("orders");

  return (
    <div className="rounded-lg border border-red-500/30 bg-red-900/20 p-6">
      <div className="flex items-center space-x-3">
        <div className="text-red-500">
          <Icon name="AlertTriangle" className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-medium text-red-400">
            {t("errors.loadTitle")}
          </h3>
          <p className="mt-1 text-sm text-red-300">
            {error?.message || t("errors.loadDescription")}
          </p>
        </div>
        {onRetry && (
          <button
            onClick={onRetry}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700"
          >
            {t("errors.retry")}
          </button>
        )}
      </div>
    </div>
  );
};

export default OrdersError;
